import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 132,
    width: '100%',
  },
}));

const OutlinedSelect = ({
  val,
  name,
  variant = 'outlined',
  handleChange,
  handleBlur,
  options,
  placeholder,
  label,
  styleOverrides,
  disabled = false,
  selectStyle,
  multiple = false,
  menuProps = false,
  error = false,
  helperText,
}) => {
  const classes = useStyles();
  const labelId = `label-${name}`;
  const selectId = `select-outlined-${name}`;

  return (
    <FormControl
      variant={variant}
      className={classes.formControl}
      disabled={disabled}
      error={error}
      size="small"
      style={styleOverrides}
    >
      {(label || placeholder) && (
        <InputLabel id={labelId}>{label || placeholder}</InputLabel>
      )}
      <Select
        labelId={labelId}
        id={selectId}
        name={name}
        value={val ?? ''}
        multiple={multiple}
        onChange={handleChange}
        onBlur={handleBlur}
        MenuProps={menuProps || undefined}
        label={(label || placeholder) || undefined}
        displayEmpty
        renderValue={(selected) => {
          if (selected === '' || selected == null) return (label || placeholder) ? null : <em>Select</em>;
          const option = options && options.find((item) => (item.id || item.uuid || item) === selected);
          return option ? (option.name || option) : selected;
        }}
        style={selectStyle || undefined}
      >
        <MenuItem value="" disabled={multiple}>
          <em>Select</em>
        </MenuItem>
        {options &&
          options.map((item, index) => (
            <MenuItem key={index} value={(item.id || item.uuid) ?? item}>
              {item.name || item}
            </MenuItem>
          ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};

OutlinedSelect.propTypes = {
  val: PropTypes.any.isRequired,
  name: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  styleOverrides: PropTypes.object,
  disabled: PropTypes.bool,
  selectStyle: PropTypes.object,
  multiple: PropTypes.bool,
  variant: PropTypes.string,
  handleBlur: PropTypes.func,
  menuProps: PropTypes.object,
  error: PropTypes.bool,
  helperText: PropTypes.node,
};

export default OutlinedSelect;
